<style scoped lang="scss">
  @import "../../common/public";

  .bottom {
    height: px2rem(55px);

    img {
      @include w_h(px2rem(25px), px2rem(25px));
    }

    li {
      min-width: 50%;
    }

    .s {
      width: px2rem(165px);
      background-color: #E3F3FF;
      color: $mainColor;
    }

    .t {
      background-color: $mainColor;
    }
  }
</style>

<template>
  <div class="bottom flex bt bg_white" v-if="info.teamPicConsultStatus||hasService">
    <router-link tag="li" :to="{path:'/team/server',query:{teamId:id,serverId:service.id}}" v-if="hasService"
                 class="s fs17 flex1 flex flex-center-2 flex-center">
      <img :src="service.serveIcon" alt="" class="mr5">{{service.serveName}}
    </router-link>
    <router-link tag="li" :to="{path:`/consult/rules`,query:{id,type:'team'}}"
                 v-if="info.teamPicConsultStatus"
                 class="t fs17 flex1 flex flex-center-2 flex-center color_fff">
      团队咨询{{info.consultPrice|formatPrice}}{{info.consultCanReplyNumber>0?'/'+info.consultCanReplyNumber+'条':''}}
    </router-link>
  </div>
</template>

<script>
  import {formatPrice} from "../../lib/filter";
  import {isEmpty} from "../../lib/util";

  export default {
    name: "team-detail-bottom",
    props: {
      id: {
        type: String,
        default: ''
      },
      info: {
        type: Object,
        default() {
          return {}
        }
      },
    },
    computed: {
      hasService() {
        const {info} = this;
        if (info.serveBindingInfoVoList && info.serveBindingInfoVoList.length) {
          const base = info.serveBindingInfoVoList[0].serveBaseInfo || {};
          return !isEmpty(base);
        }
        return false;
      },
      service() {
        const {info, hasService} = this;
        if (hasService) {
          return info.serveBindingInfoVoList[0] && info.serveBindingInfoVoList[0].serveBaseInfo || {};
        }
        return {};
      }
    },
    filters: {
      formatPrice
    }
  }
</script>




// WEBPACK FOOTER //
// src/plugins/team/team-detail-bottom.vue